import { fetchJSON } from "@/src/requests/utils/fetch-json";

export interface LocationProvidersResponse {
  providers: string[];
  department: { id: string; name: string; assignee: string | null; providerGroup?: string } | null;
}

export async function getLocationAndProvidersMappingInstructions(
  locationId: string
): Promise<LocationProvidersResponse> {
  return fetchJSON<LocationProvidersResponse>("/api/location-providers-instructions", {
    method: "POST",
    body: JSON.stringify({ locationId }),
  });
}
